import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProjectEmailComponent } from './project-email.component';

const routes: Routes = [
  {
    path: '',
    component: ProjectEmailComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProjectEmailRoutingModule {}
